import { type VehicleDTOExtended } from '../services/vehicles.service'

export function getOwnershipId (vehicle: VehicleDTOExtended): number | null {
  const ownershipId = vehicle?.ownershipId
  return typeof ownershipId === 'number' ? ownershipId : null
}
